import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { StaticAddress } from "@/components/Checkout/CheckoutCustomer/addresses/components/staticAddress/staticAddress";
import { useAddresses } from "@/components/Checkout/CheckoutCustomer/addresses/hooks/useAddresses.hook";
import { CheckoutCustomerFormValues } from "@/components/Checkout/CheckoutCustomer/checkoutCustomer.schema";
import { CustomerAddressFormBlock } from "@/components/Form/RHF/FormBlocks/Address/addressFormBlock.container";
import * as CheckoutCustomerDetailsFormSelectors from "@/redux/modules/value/checkout/customerDetails/checkoutCustomerDetailsForm.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const DeliveryAddress = ({ className }: Props) => {
    const { t } = useGranite();

    const { deliveryAddresses } = useAddresses();

    const checkoutCustomerDetailsForm = useSelector(
        CheckoutCustomerDetailsFormSelectors.getCheckoutCustomerDetailsForm
    );

    const deliveryAddressId = checkoutCustomerDetailsForm?.deliveryAddressId;
    const deliveryAddress = deliveryAddresses.find(({ id }) => {
        return id === deliveryAddressId && !!id;
    });

    return (
        <section className={cn(className)}>
            <h2>{t("checkout.customerDetails.deliveryAddress.title")}</h2>
            <hr />
            <p>
                <i>{t("checkout.customerDetails.deliveryAddress.subtitle")}</i>
            </p>
            {!!deliveryAddress && (
                <StaticAddress
                    address={deliveryAddress}
                    addressType={AddressType.Delivery}
                />
            )}
            {!deliveryAddress && (
                <CustomerAddressFormBlock<
                    CheckoutCustomerFormValues,
                    AddressType.Delivery
                >
                    addressType={AddressType.Delivery}
                    addressStatus={AddressValidationStatus.Unknown}
                    skipValidation={true}
                />
            )}
        </section>
    );
};
